import { render, staticRenderFns } from "./OrderProcessStart.vue?vue&type=template&id=6c8798df&scoped=true&"
import script from "./OrderProcessStart.vue?vue&type=script&lang=js&"
export * from "./OrderProcessStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8798df",
  null
  
)

export default component.exports